// R111 — THE NUMEROLOGY POPUP'S OWN FIELD BLOCK, AND IT MOVED BECAUSE IT IS WHAT THIS ROUND IS ABOUT.
//
// Numerology's fields: the full name at birth (middle name required, it feeds the numbers) and the
// birth date. Nothing else, because nothing else changes a number.
//
// It was an arrow function inside a nine-hook modal, rendered TWICE per popup (her numbers and her
// partner's), and it was one of the three surfaces 14-B6c's fix never reached — `NameFields` with no
// `language` and `Birth date` hand-typed beside it, under a modal label, a hint, a status line and a
// button that were all already in Spanish. **A law inside a hook-holding component is a law nothing
// can run** (roadmap 7's whole argument), so R111's own rule was held over it by a source parse and
// by nothing else.
//
// Out here it is props-in / tree-out with no hook, so `scripts/r111-birth-form-language.mjs` CALLS
// it and reads the rendered date label back in both languages — which is the difference between
// "the prop is written at the call site" and "the words she sees change".
import { NameFields, type BirthChartForm } from "./BirthFields";
import { DEFAULT_LANGUAGE } from "../language.js";
import { t } from "../strings.js";

export function NumberFields({ value, onUpdate, hint, language = DEFAULT_LANGUAGE }: {
  value: BirthChartForm;
  onUpdate: <K extends keyof BirthChartForm>(field: K, v: BirthChartForm[K]) => void;
  hint: string;
  // 14-B2's shape, kept: a DEFAULT rather than a required prop, because the three blocks under this
  // one are defaults too and a single required link in that chain would be the odd one out.
  language?: string;
}) {
  return (
    <div className="numerology-mini__fields">
      <div className="form-row form-row--name">
        <NameFields first={value.firstName} middle={value.middleName} last={value.lastName} onChange={onUpdate} language={language} />
        <p className="birth-chart-form__hint">{hint}</p>
      </div>
      <label className="form-field--date">
        <span>{t(language, "form.birthDate")}</span>
        <input type="date" value={value.birthDate} onChange={(e) => onUpdate("birthDate", e.target.value)} required />
      </label>
    </div>
  );
}
